import { render, staticRenderFns } from "./Inquire.vue?vue&type=template&id=5586cf74&"
import script from "./Inquire.vue?vue&type=script&lang=js&"
export * from "./Inquire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports